import { render, staticRenderFns } from "./ValutazioneOffertaPageDetails.vue?vue&type=template&id=13516118&"
import script from "./ValutazioneOffertaPageDetails.vue?vue&type=script&lang=ts&"
export * from "./ValutazioneOffertaPageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCardTitle,VContainer,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13516118')) {
      api.createRecord('13516118', component.options)
    } else {
      api.reload('13516118', component.options)
    }
    module.hot.accept("./ValutazioneOffertaPageDetails.vue?vue&type=template&id=13516118&", function () {
      api.rerender('13516118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/ValutazioneOffertaPageDetails.vue"
export default component.exports